import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section id="final" className="w-full bg-ink-strong" aria-labelledby="final-titulo" data-id="element-54" data-mp="3udp26xtznyt6">
      <div className="mx-auto flex max-w-2xl flex-col items-center px-5 py-10 text-center sm:px-6 sm:py-14" data-id="element-55" data-mp="c7tw1mrnowv3">
        <h2 id="final-titulo" className="font-display text-[1.6rem] leading-[1.05] text-white sm:text-4xl" data-id="element-56" data-mp="84e2izavvcmm">
          Dejá de improvisar. Ordena tu Airbnb hoy.
        </h2>
        <p className="mt-3 max-w-md text-sm text-white/70" data-id="element-57" data-mp="h52hpxc0jj13">
          Acceso inmediato al sistema completo: 6 tomos, 5 bonos, mensajes,
          checklists y protocolos.
        </p>

        <div className="mt-5 hidden sm:block" data-id="element-58" data-mp="qwq2jfe2e1tl">
          <Countdown seconds={3 * 3600 + 4 * 60 + 46} tone="dark" compact data-id="element-59" data-mp="qy15jczor5jn" />
        </div>

        <p className="mt-5 flex items-end gap-2" data-id="element-60" data-mp="14tdb6ffdqgfc">
          <span className="font-display text-5xl leading-none text-white sm:text-6xl" data-id="element-61" data-mp="zx4pskal9qzq">
            $19
          </span>
          <span className="font-display pb-1 text-lg leading-none text-white/60" data-id="element-62" data-mp="2c5y9pmy3ghdd">
            USD
          </span>
        </p>

        <div className="mt-5 w-full max-w-sm" data-id="element-63" data-mp="2h5u4cvkwiwg9">
          <CTAButton label="Quiero mi Airbnb automatizado" size="lg" fullWidth href="#precio" data-id="element-64" data-mp="2m2kukbqf78fe" />
        </div>
        <p className="mt-3 text-[11px] font-semibold text-white/60" data-id="element-65" data-mp="2r2ys2zueazz6">
          Pago único · Sin suscripciones · Acceso inmediato · Pagas en tu moneda
          local
        </p>
      </div>
    </section>;
}